import React, { useState, useEffect } from "react";
import MaterialTable from "material-table";
import Axios from "axios";

import {
  MDBRow,
  MDBCol,
  MDBIcon,
  MDBModal,
  MDBCard,
  MDBCardBody,
  MDBCardHeader,
  MDBBtn,
} from "mdbreact";

import "../css/scrollbar.css";

import Spinner from "../components/Spinner";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBan,
  faCalendarPlus,
  faCheck,
  faChevronUp,
  faCompress,
  faHourglassHalf,
  faPenToSquare,
  faRotateLeft,
} from "@fortawesome/free-solid-svg-icons";
import AddEditAppointmentCustomerView from "./AddEditAppointmentCustomerView";

const AppointmentCustomerView = (props) => {
  const bearer = {
    headers: {
      Authorization: "Bearer " + sessionStorage.getItem("hash"),
    },
  };
  const [rows, setRows] = useState([]);
  const [showPreloader, setPreloader] = useState("normal");

  const [modalAddEdit, showAddEdit] = useState(false);

  const toggleAddEdit = () => {
    showAddEdit(!modalAddEdit);
    loadData();
  };

  const [bRefresh, setRefresh] = useState(false);
  function refreshGrid() {
    setRefresh(!bRefresh);
    loadData();
  }

  function loadData() {
    Axios.get(
      props.apiServer +
        "/myappointment?usercode=" +
        sessionStorage.getItem("msal.uc"),
      bearer
    )
      .then((res) => {
        setRows(res.data);
        setPreloader("none");
      })

      .catch((error) => {
        console.log(error);
      });
  }

  const useMountEffect = (functionName) => useEffect(functionName, []);
  useMountEffect(loadData);
  return (
    <React.Fragment>
      <MDBRow>
        <MDBCol md="12">
          {showPreloader === "normal" ? (
            <Spinner />
          ) : (
            <React.Fragment>
              <MDBRow>
                <MDBCol md="8">
                  <span className="h5-responsive font-weight-bold">
                    APPOINTMENTS
                  </span>
                  &nbsp;|&nbsp;
                  <span className="h6-responsive font-weight-bold brown-text">
                    {sessionStorage.getItem("Email")}
                  </span>
                </MDBCol>
                <MDBCol md="4">
                  <MDBBtn
                    onClick={toggleAddEdit}
                    className="cloudy-knoxville-gradient brown-text float-right"
                  >
                    <FontAwesomeIcon icon={faCalendarPlus} /> Book an
                    Appointment
                    {/* <MDBIcon
                      icon="calendar-plus"
                      size="1x"
                      className="brown-text"
                      title="Book an Appointment"
                    /> */}
                  </MDBBtn>
                </MDBCol>
              </MDBRow>

              <MaterialTable
                title=""
                columns={[
                  { title: "Appointment Code", field: "code" },
                  { title: "Target Date", field: "targetdatetext" },
                  { title: "Target Time", field: "targettimetext" },

                  { title: "Approved Date", field: "approveddatetext" },
                  { title: "Approved Time", field: "approvedtimetext" },
                  {
                    title: "Appointment Status",
                    field: "appointmentstatus",
                    render: (rowData) => {
                      return rowData.appointmentstatuscode === "0" ? (
                        <>
                          <span className="font-weight-bold red-text small">
                            <FontAwesomeIcon icon={faHourglassHalf} />{" "}
                            {rowData.appointmentstatus}
                          </span>
                        </>
                      ) : rowData.appointmentstatuscode === "1" ? (
                        <>
                          <span className="font-weight-bold blue-text small">
                            <FontAwesomeIcon icon={faCheck} />{" "}
                            {rowData.appointmentstatus}
                          </span>
                        </>
                      ) : rowData.appointmentstatuscode === "2" ? (
                        <>
                          <span className="font-weight-bold dark-grey-text small">
                            <FontAwesomeIcon icon={faRotateLeft} />{" "}
                            {rowData.appointmentstatus}
                          </span>
                        </>
                      ) : (
                        <>
                          <span className="font-weight-bold grey-text small">
                            <FontAwesomeIcon icon={faBan} />{" "}
                            {rowData.appointmentstatus}
                          </span>
                        </>
                      );
                    },
                  },
                ]}
                data={rows}
                options={{
                  search: true,
                  actionsColumnIndex: -1,
                }}
                detailPanel={[
                  {
                    icon: () => <FontAwesomeIcon icon={faPenToSquare} />,
                    openIcon: () => (
                      <FontAwesomeIcon
                        className="red-text font-weight-bold"
                        icon={faChevronUp}
                      />
                    ),
                    tooltip: "Appointment Details",
                    render: (rowData) => {
                      return (
                        <React.Fragment>
                          <MDBCard>
                            <MDBCardHeader>Appointment Details</MDBCardHeader>
                            <MDBCardBody>
                              <AddEditAppointmentCustomerView
                                deployURL={props.deployURL}
                                apiServer={props.apiServer}
                                code={rowData.code}
                                apiServerHybrid={props.apiServerHybrid}
                                toggleModal={toggleAddEdit}
                                refreshGrid={refreshGrid}
                                quicktool="no"
                              />
                            </MDBCardBody>
                          </MDBCard>
                        </React.Fragment>
                      );
                    },
                  },
                ]}
              />
            </React.Fragment>
          )}
        </MDBCol>
      </MDBRow>

      <MDBModal
        backdrop={false}
        isOpen={modalAddEdit}
        toggleModal={toggleAddEdit}
        fullHeight
        position="right"
        size="lg"
      >
        <MDBCard>
          <MDBCardHeader className="primary-color">
            <h5 className="h5-responsive white-text">
              <b>Book an Appointment</b>
            </h5>
          </MDBCardHeader>
          <MDBCardBody>
            <AddEditAppointmentCustomerView
              deployURL={props.deployURL}
              apiServer={props.apiServer}
              apiServerHybrid={props.apiServerHybrid}
              code={""}
              toggleModal={toggleAddEdit}
              refreshGrid={refreshGrid}
              // toggleModal2={props.toggleModal2}
              // quicktool="yes"
            />
          </MDBCardBody>
        </MDBCard>

        {/* <AddEditDirectiveDetails toggleModal={toggleAddEdit} code={"newrecord"} directivecode={props.code}  apiServer={props.apiServer} loadDirectivesMain={props.loadDirectivesMain}/> */}
      </MDBModal>

      {/*    <ToastContainer
                        hideProgressBar={true}
                        newestOnTop={true}
                        autoClose={5000}
                    /> */}
    </React.Fragment>
  );
};

export default AppointmentCustomerView;
